let collectionEnabled = process.env.INTL_COLLECT_USAGE === 'true'
const isNode = typeof window === 'undefined'
const packageName = process.env.GATSBY_PACKAGE_NAME || 'main'
const usageFileName = `intl-ssr-usage-${packageName}.jsonl`
const pageMapFileName = `intl-page-map-${packageName}.json`

let currentPagePath = null
let patched = false
const recordedKeys = new Set()
const pageMap = {}

const getNodeModules = () => {
  if (!isNode) return {}
  const nodeRequire = typeof __non_webpack_require__ === 'function' ? __non_webpack_require__ : eval('require')
  return {
    fs: nodeRequire('fs'),
    path: nodeRequire('path'),
  }
}

const getCollectionPaths = () => {
  const { fs, path } = getNodeModules()
  if (!fs || !path) return {}
  const fallbackCacheDir =
    process.cwd && process.cwd() !== '/' ? path.join(process.cwd(), '.cache') : path.join(__dirname, '.cache')
  const cacheDir = process.env.INTL_COLLECT_CACHE_DIR || fallbackCacheDir
  fs.mkdirSync(cacheDir, { recursive: true })
  return {
    usagePath: path.join(cacheDir, usageFileName),
    pageMapPath: path.join(cacheDir, pageMapFileName),
  }
}

const writeJson = (filePath, value) => {
  const { fs } = getNodeModules()
  if (!fs) return
  fs.writeFileSync(filePath, `${JSON.stringify(value, null, 2)}\n`)
}

const setCurrentPagePath = pagePath => {
  if (!collectionEnabled) return
  currentPagePath = pagePath
}

const enableCollection = () => {
  collectionEnabled = true
}

const isCollectMode = () => collectionEnabled

const resetCollectionFiles = () => {
  const { fs } = getNodeModules()
  const { usagePath, pageMapPath } = getCollectionPaths()
  if (!fs || !usagePath || !pageMapPath) return
  if (fs.existsSync(usagePath)) fs.unlinkSync(usagePath)
  if (fs.existsSync(pageMapPath)) fs.unlinkSync(pageMapPath)
}

const recordPage = page => {
  if (!collectionEnabled || !page || !page.path) return
  const { pageMapPath } = getCollectionPaths()
  if (!pageMapPath) return
  pageMap[page.path] = {
    path: page.path,
    component: page.component,
    namespaces: page.namespaces || [],
    keys: page.keys || [],
  }
  writeJson(pageMapPath, { pages: pageMap })
}

const recordKey = (key, type) => {
  if (!collectionEnabled || !currentPagePath || typeof key !== 'string') return
  const { fs } = getNodeModules()
  const { usagePath } = getCollectionPaths()
  if (!fs || !usagePath) return
  const id = `${currentPagePath}:${type}:${key}`
  if (recordedKeys.has(id)) return
  recordedKeys.add(id)
  fs.appendFileSync(usagePath, `${JSON.stringify({ path: currentPagePath, key, type })}\n`)
}

const patchIntl = intl => {
  if (!collectionEnabled || patched || !intl) return
  patched = true

  const originalGet = intl.get && intl.get.bind(intl)
  const originalGetHTML = intl.getHTML && intl.getHTML.bind(intl)

  if (originalGet) {
    intl.get = (key, ...args) => {
      recordKey(key, 'get')
      return originalGet(key, ...args)
    }
  }

  if (originalGetHTML) {
    intl.getHTML = (key, ...args) => {
      recordKey(key, 'getHTML')
      return originalGetHTML(key, ...args)
    }
  }
}

module.exports = {
  enableCollection,
  isCollectMode,
  patchIntl,
  recordPage,
  resetCollectionFiles,
  setCurrentPagePath,
}
